import {
  Button,
  Card,
  CardContent,
  Grid,
  TextField,
  Typography,
  Divider,
} from "@mui/material";
import ArrowBackSharpIcon from "@mui/icons-material/ArrowBackSharp";
import React, { useState, useEffect } from "react";
import axios from "axios";
import { Navigate, useNavigate } from "react-router-dom";
import HOST_URL from "../../../utils/Url";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import { VoicemailOutlined } from "@mui/icons-material";
import ToastApp from "../../../ToastApp";
import Autocomplete from "@mui/material/Autocomplete";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import api from "../../../utils/Url";
import { faL } from "@fortawesome/free-solid-svg-icons";

type Props = {};

const FileAssigning = (props: Props) => {
  let navigate = useNavigate();
  const { i18n, t } = useTranslation();
  const back = useNavigate();
  const [toaster, setToaster] = useState(false);
  const [assignbtn, setAssignbtn] = useState(false);
  const [epcFetched, setEpcFetched] = useState(false); // New state to track if EPC was fetched
  
  const requiredFields = ["dept_id", "designation_name"];
  const [antina, setAntina] = useState(0);
  const [epcnumber, setGetepc] = useState("");
  const [option, setOption] = useState([
    { value: "-1", label: t("text.selectfiledetails") },
  ]);
  const [LocationOption, setLocOption] = useState([
    { value: "-1", label: t("text.selectMapLoc") },
  ]);

  const handleChange = (event: any) => {
    setAntina(event.target.value);
  };

  const assignbook = async () => {
    const collectData = {
      fileID: formik.values.fileID,
      rfid: epcnumber,
    };
    const response = await api.post(
       `FileDetail/AddUpdateFileDetails`,
      collectData
    );
    if (response.data.isSuccess) {
      setToaster(false);
      setGetepc("");
      formik.setFieldValue("fileID", 0);
      formik.setFieldValue("fileName", "");
      toast.success(response.data.mesg);
    } else {
      setToaster(true);
      toast.error(response.data.mesg);
    }
  };

  const assignLocation = async () => {
    if (formik.values.fileID == "") {
      toast.error("Please Select File No.");
      return false;
    }
    if (formik.values.currentLocation == "") {
      toast.error("Please Select Location");
      return false;
    }
    const collectData = {
      fileID: formik.values.fileID,
      currentLocation: formik.values.currentLocation + "",
    };
    const response = await api.post(
       `FileDetail/AddUpdateFileDetails`,
      collectData
    );
    if (response.data.isSuccess) {
      setGetepc("");
      formik.setFieldValue("fileID", 0);
      formik.setFieldValue("currentLocation", "");
      toast.success(response.data.mesg);
    } else {
      toast.error(response.data.mesg);
    }
  };

  const accept = async() => {
    if (!formik.values.fileID ) {
      if (!formik.values.fileID) {
        toast.error("Please select File Details");
      }
      return;
    }
    const collectData = {
      fileID: formik.values.fileID,
      rfid: "",
    };
    const response = await api.post(
       `FileDetail/AddUpdateFileDetails`,
      collectData
    );
    if (response.data.isSuccess) {
      setToaster(false);
      setAssignbtn(false);
      formik.setFieldValue("fileID", 0);
      formik.setFieldValue("fileName", "");
      toast.success(response.data.mesg);
    } else {
      setToaster(true);
      toast.error(response.data.mesg);
    }
  };

  const reject = () => {
    toast.warn("Rejected: You have rejected", { autoClose: 3000 });
  };

  const handledeleteClick = () => {
    console.log( "del_id ");
    
    confirmDialog({
      message:  t("text.DoYouWantToDeleteThisRecord"),
      header: t("text.DeleteConfirmation"),
      icon: "pi pi-info-circle",
      acceptClassName: "p=-button-danger",
      accept,
      reject,
    });
  };
  
  const getepc = async () => {
    if (antina == 0) {
      toast.error("Please Select Any one Antenna");
      return false;
    }

    const collectData = {
      id: -1,
      epc: "",
      antnum: parseInt(antina.toString()),
      type: "Assign",
    };
    const response = await api.post(
       `AssigningRfid/GetRfid`,
      collectData
    );
    if (response.data.isSuccess) {
      if (response.data.data.length > 0) {
        setGetepc(response.data.data[0]["epc"]);
        setEpcFetched(true); // Enable other buttons after successful EPC fetch
      } else {
        toast.error("NO RFID Card Details ");
      }
      setAssignbtn(false);
    } else {
      toast.error(response.data.mesg);
      setGetepc(response.data.data[0]["epc"]);
      setAssignbtn(true);
      setEpcFetched(true); // Enable other buttons even if there's an error (if needed)
    }
  };

  const resetForm = () => {
    formik.resetForm();
    setGetepc("");
    setAntina(0);
    setEpcFetched(false); // Disable other buttons when form is reset
  };

  const validationSchema = Yup.object({
    designation_name: Yup.string().test(
      "required",
      t("text.reqdeadditem"),
      function (value: any) {
        return value && value.trim() !== "";
      }
    ),
    dept_id: Yup.string().test(
      "required",
      t("text.reqdAlias"),
      function (value: any) {
        return value && value.trim() !== "";
      }
    ),
  });

  useEffect(() => {
    getDeptbyId();
  }, []);
  const getDeptbyId = () => {
    const collectData = {

        "fileID": -1,
  "chackNo": "",
  "fileType": -1,
  "fileGroup": -1,
  "fileCategory": -1,
  "fileClass": -1,
  "fileSubject": -1,
  "zoneID": -1,
  "wardID": -1

//       fileID: -1,
//       fileType: -1,
//       fileGroup: -1,
//       fileCategory: -1,
//       fileClass: -1,
//       fileSubject: -1,
//         zoneID: -1,
//   wardID: -1

    };
    api
      .post(`FileDetail/GetFileDetails`, collectData)
      .then((res) => {
        const arr: any = [];
        console.log("result" + JSON.stringify(res.data.data));
        for (let index = 0; index < res.data.data.length; index++) {
          arr.push({
            label:
              res.data.data[index]["fileNo"] +
              " - " +
              res.data.data[index]["fileName"],
            value: res.data.data[index]["fileID"],
          });
        }
        setOption(arr);
      });
  };

  useEffect(() => {
    getLocbyId();
  }, []);
  const getLocbyId = () => {
    const collectData = {
      id: -1,
    };
    api
      .post( `LocationItems/GetMappedLocation`, collectData)
      .then((res) => {
        const arr: any = [];
        console.log("result" + JSON.stringify(res.data.data));
        for (let index = 0; index < res.data.data.length; index++) {
          arr.push({
            label: res.data.data[index]["location"],
            value: res.data.data[index]["id"],
          });
        }
        setLocOption(arr);
      });
  };

  const formik = useFormik({
    initialValues: {
      fileID: "",
      rfid: "",
      fileName: "",
      currentLocation: "",
      id: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {},
  });

  return (
    <div>
      <div
        style={{
          padding: "-5px 5px",
          backgroundColor: "#ffffff",
          borderRadius: "5px",
          marginTop: "3vh",
        }}
      >
        <CardContent>
        <ConfirmDialog />
          <ToastApp />
          <Typography
            variant="h5"
            textAlign="center"
            style={{ fontSize: "18px", fontWeight: 500 }}
          >
           {t("text.GetEpc")}
          </Typography>
          <br />
          <Divider />
          <br />
          <form>
            <Grid item xs={12} container spacing={2}>

              <Grid item lg={12} xs={12}>
                <FormControl>
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                    onChange={(e) => handleChange(e)}
                  >
                    <FormControlLabel
                      value="1"
                      control={<Radio />}
                      label="Antenna-1"
                    />
                    <FormControlLabel
                      value="2"
                      control={<Radio />}
                      label="Antenna-2"
                    />
                    <FormControlLabel
                      value="3"
                      control={<Radio />}
                      label="Antenna-3"
                    />
                    <FormControlLabel
                      value="4"
                      control={<Radio />}
                      label="Antenna-4"
                    />
                    <FormControlLabel
                      value="8"
                      control={<Radio />}
                      label="Antenna-8"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>

              {/*Epc   */}

              <Grid item lg={8} xs={12}>
                <TextField
                  label={t("text.EpcNumber")}
                  value={epcnumber}
                  placeholder={t("text.EpcNumber")}
                  size="small"
                  fullWidth
                />
              </Grid>

              <Grid item lg={2} sm={2} xs={2}>
                <Grid>
                  <Button
                    fullWidth
                    style={{
                      backgroundColor: "#059669",
                      color: "white",
                      marginTop: "2px",
                    }}
                    onClick={() => getepc()}
                  >
                    {t("text.GetEpc")}
                  </Button>
                </Grid>
              </Grid>

              {/*Accession-No  */}
              <Grid xs={12} sm={8} item>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={option}
                  fullWidth
                  size="small"
                  disabled={!epcFetched} // Disable until EPC is fetched
                  onChange={(event, newValue) => {
                    if (newValue == null) {
                      formik.setFieldValue("fileID", "");
                    } else {
                      console.log(newValue?.value);
                      formik.setFieldValue("fileID", newValue?.value);
                      formik.setFieldValue("fileName", newValue?.label);
                      formik.setFieldTouched("fileID", true);
                      formik.setFieldTouched("fileID", false);
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        <span>
                          {t("text.selectfiledetails")}{" "}
                          {requiredFields.includes("dept_id") && (
                            <span
                              style={{
                                color: formik.values.fileID ? "green" : "red",
                              }}
                            >
                              *
                            </span>
                          )}
                        </span>
                      }
                    />
                  )}
                />
                {formik.touched.fileID && formik.errors.fileID ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {formik.errors.fileID}
                  </div>
                ) : null}
              </Grid>

              <Grid item lg={1.5} sm={1.5} xs={1.5}>
                <Grid>
                  <Button
                    fullWidth
                    style={{
                        backgroundColor: !epcFetched ? "#e0e0e0" : "#059669",
                      color: "white",
                      marginTop: "2px",
                    }}
                    disabled={!epcFetched || assignbtn} // Disable until EPC is fetched
                    onClick={() => assignbook()}
                  >
                    {t("text.AssignBook")}
                  </Button>
                </Grid>
              </Grid>

              <Grid item lg={1.5} sm={1.5} xs={1.5}>
                <Grid>
                  <Button
                    fullWidth
                    style={{
                     backgroundColor: !epcFetched ? "#e0e0e0" : "#059669",
                      color: "white",
                      marginTop: "2px",
                    }}
                    disabled={!epcFetched} // Disable until EPC is fetched
                    onClick={handledeleteClick}
                  >
                   {t("text.EPCDelete")}
                  </Button>
                </Grid>
              </Grid>

              <Grid xs={12} sm={8} item>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={LocationOption}
                  fullWidth
                  size="small"
                  disabled={!epcFetched} // Disable until EPC is fetched
                  onChange={(event, newValue) => {
                    if (newValue == null) {
                      formik.setFieldValue("currentLocation", "");
                    } else {
                      console.log(newValue?.value);
                      formik.setFieldValue("currentLocation", newValue?.value);
                      formik.setFieldTouched("currentLocation", true);
                      formik.setFieldTouched("currentLocation", false);
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        <span>
                          {t("text.selectMapLoc")}{" "}
                          {requiredFields.includes("currentLocation") && (
                            <span
                              style={{
                                color: formik.values.id ? "green" : "red",
                              }}
                            >
                              *
                            </span>
                          )}
                        </span>
                      }
                    />
                  )}
                />
                {formik.touched.id && formik.errors.id ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {formik.errors.id}
                  </div>
                ) : null}
              </Grid>

              <Grid item lg={3} sm={3} xs={3}>
                <Grid>
                  <Button
                  fullWidth
                  style={{
                    backgroundColor: !epcFetched ? "#e0e0e0" : "#059669",
                    color: "white",
                    marginTop: "2px",
                  }}
                  disabled={!epcFetched} // Disable until EPC is fetched
                  onClick={() => assignLocation()}
                  >
                   {t("text.AssignLocation")}
                  </Button>
                </Grid>
              </Grid>
              {/*button  */}
              <Grid
                item
                xs={12}
                container
                spacing={2}
                alignItems="center"
                justifyContent="center"
              >
                <Grid item lg={2} sm={2} xs={2}>
                  <Button
                    type="reset"
                    fullWidth
                    style={{
                      backgroundColor: "#F43F5E",
                      color: "white",
                      marginTop: "10px",
                    }}
                    onClick={resetForm} // Use the resetForm function
                  >
                    {t("text.reset")}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </form>
        </CardContent>
      </div>
    </div>
  );
};

export default FileAssigning;










// import {
//   Button,
//   Card,
//   CardContent,
//   Grid,
//   TextField,
//   Typography,
//   Divider,
// } from "@mui/material";
// import ArrowBackSharpIcon from "@mui/icons-material/ArrowBackSharp";
// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { Navigate, useNavigate } from "react-router-dom";
// import HOST_URL from "../../../utils/Url";
// import { useFormik } from "formik";
// import * as Yup from "yup";
// import { useTranslation } from "react-i18next";
// import { toast } from "react-toastify";
// import FormGroup from "@mui/material/FormGroup";
// import FormControlLabel from "@mui/material/FormControlLabel";
// import Checkbox from "@mui/material/Checkbox";
// import Radio from "@mui/material/Radio";
// import RadioGroup from "@mui/material/RadioGroup";
// import FormControl from "@mui/material/FormControl";
// import FormLabel from "@mui/material/FormLabel";
// import { VoicemailOutlined } from "@mui/icons-material";
// import ToastApp from "../../../ToastApp";
// import Autocomplete from "@mui/material/Autocomplete";
// import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
// import api from "../../../utils/Url";
// import { faL } from "@fortawesome/free-solid-svg-icons";

// type Props = {};

// const FileAssigning = (props: Props) => {
//   let navigate = useNavigate();
//   const { i18n, t } = useTranslation();
//   const back = useNavigate();
//   const [toaster, setToaster] = useState(false);
//   const [assignbtn, setAssignbtn] = useState(false);
  
//   const requiredFields = ["dept_id", "designation_name"];
//   const [antina, setAntina] = useState(0);
//   const [epcnumber, setGetepc] = useState("");
//   const [option, setOption] = useState([
//     { value: "-1", label: t("text.selectfiledetails") },
//   ]);
//   const [LocationOption, setLocOption] = useState([
//     { value: "-1", label: t("text.selectMapLoc") },
//   ]);

//   const handleChange = (event: any) => {
//     setAntina(event.target.value);
//   };

//   const assignbook = async () => {


//     const collectData = {
//       fileID: formik.values.fileID,
//       //"fileName":formik.values.fileName,
//       rfid: epcnumber,
//     };
//     const response = await api.post(
//        `FileDetail/AddUpdateFileDetails`,
//       collectData
//     );
//     if (response.data.isSuccess) {
//       setToaster(false);
//       setGetepc("");

//       formik.setFieldValue("fileID", 0);
//       formik.setFieldValue("fileName", "");
//       toast.success(response.data.mesg);
//     } else {
//       setToaster(true);
//       toast.error(response.data.mesg);
//     }
//   };

//   const assignLocation = async () => {
//     if (formik.values.fileID == "") {
//       toast.error("Please Select File No.");
//       return false;
//     }
//     if (formik.values.currentLocation == "") {
//       toast.error("Please Select Location");
//       return false;
//     }
//     const collectData = {
//       fileID: formik.values.fileID,
//       //"fileName":formik.values.fileName,
//       currentLocation: formik.values.currentLocation + "",
//     };
//     const response = await api.post(
//        `FileDetail/AddUpdateFileDetails`,
//       collectData
//     );
//     if (response.data.isSuccess) {
//       setGetepc("");

//       formik.setFieldValue("fileID", 0);
//       formik.setFieldValue("currentLocation", "");
//       toast.success(response.data.mesg);
//     } else {
//       toast.error(response.data.mesg);
//     }
//   };

//   const accept = async() => {
//     if (!formik.values.fileID ) {
//       if (!formik.values.fileID) {
//         toast.error("Please select File Details");
//       }
//       return;
//     }
//     const collectData = {
//       fileID: formik.values.fileID,
//       rfid: "",
//     };
//     const response = await api.post(
//        `FileDetail/AddUpdateFileDetails`,
//       collectData
//     );
//     if (response.data.isSuccess) {
//       setToaster(false);
//       //setGetepc("");
//       setAssignbtn(false);
//       formik.setFieldValue("fileID", 0);
//       formik.setFieldValue("fileName", "");
//       toast.success(response.data.mesg);
//     } else {
//       setToaster(true);
//       toast.error(response.data.mesg);
//     }
//   };

//   const reject = () => {
//     toast.warn("Rejected: You have rejected", { autoClose: 3000 });
//   };

//   const handledeleteClick = () => {
//     console.log( "del_id ");
    
//     confirmDialog({
//       message:  t("text.DoYouWantToDeleteThisRecord"),
//       header: t("text.DeleteConfirmation"),
//       icon: "pi pi-info-circle",
//       acceptClassName: "p=-button-danger",
//       accept,
//       reject,
//     });
//   };
  
//   const getepc = async () => {
//     if (antina == 0) {
//       toast.error("Please Select Any one Antenna");
//       return false;
//     }

//     const collectData = {
//       id: -1,
//       epc: "",
//       antnum: parseInt(antina.toString()),
//       type: "Assign",
//     };
//     const response = await api.post(
//        `AssigningRfid/GetRfid`,
//       collectData
//     );
//     if (response.data.isSuccess) {
//       // console.log(response.data.data[0]["epc"]);
//       if (response.data.data.length > 0) {
//         setGetepc(response.data.data[0]["epc"]);
//       } else {
//         toast.error("NO RFID Card Details ");
//       }
//       setAssignbtn(false);
//     } else {
      
//       toast.error(response.data.mesg);
//       setGetepc(response.data.data[0]["epc"]);
//       setAssignbtn(true);
//     }
//   };
//   const validationSchema = Yup.object({
//     designation_name: Yup.string().test(
//       "required",
//       t("text.reqdeadditem"),
//       function (value: any) {
//         return value && value.trim() !== "";
//       }
//     ),
//     dept_id: Yup.string().test(
//       "required",
//       t("text.reqdAlias"),
//       function (value: any) {
//         return value && value.trim() !== "";
//       }
//     ),
//   });

//   useEffect(() => {
//     getDeptbyId();
//   }, []);
//   const getDeptbyId = () => {
//     const collectData = {
//       fileID: -1,
//       fileType: -1,
//       fileGroup: -1,
//       fileCategory: -1,
//       fileClass: -1,
//       fileSubject: -1,
//     };
//     api
//       .post(`FileDetail/GetFileDetails`, collectData)
//       .then((res) => {
//         const arr: any = [];
//         console.log("result" + JSON.stringify(res.data.data));
//         for (let index = 0; index < res.data.data.length; index++) {
//           arr.push({
//             label:
//               res.data.data[index]["fileNo"] +
//               " - " +
//               res.data.data[index]["fileName"],
//             value: res.data.data[index]["fileID"],
//           });
//         }
//         setOption(arr);
//       });
//   };

//   useEffect(() => {
//     getLocbyId();
//   }, []);
//   const getLocbyId = () => {
//     const collectData = {
//       id: -1,
//     };
//     api
//       .post( `LocationItems/GetMappedLocation`, collectData)
//       .then((res) => {
//         const arr: any = [];
//         console.log("result" + JSON.stringify(res.data.data));
//         for (let index = 0; index < res.data.data.length; index++) {
//           arr.push({
//             label: res.data.data[index]["location"],
//             value: res.data.data[index]["id"],
//           });
//         }
//         setLocOption(arr);
//       });
//   };

//   const formik = useFormik({
//     initialValues: {
//       fileID: "",
//       rfid: "",
//       fileName: "",
//       currentLocation: "",
//       id: "",
//     },
//     validationSchema: validationSchema,
//     onSubmit: async (values) => {},
//   });

//   return (
//     <div>
//       <div
//         style={{
//           padding: "-5px 5px",
//           backgroundColor: "#ffffff",
//           borderRadius: "5px",
//           marginTop: "3vh",
//           // border: ".5px solid #FF7722",
//         }}
//       >
//         <CardContent>
//         <ConfirmDialog />
//           <ToastApp />
//           <Typography
//             variant="h5"
//             textAlign="center"
//             style={{ fontSize: "18px", fontWeight: 500 }}
//           >
//            {t("text.GetEpc")}
//           </Typography>
//           <br />
//           <Divider />
//           <br />
//           <form>
//             <Grid item xs={12} container spacing={2}>

//               <Grid item lg={12} xs={12}>
//                 <FormControl>
//                   <RadioGroup
//                     row
//                     aria-labelledby="demo-row-radio-buttons-group-label"
//                     name="row-radio-buttons-group"
//                     onChange={(e) => handleChange(e)}
//                   >
//                     <FormControlLabel
//                       value="1"
//                       control={<Radio />}
//                       label="Antenna-1"
//                     />
//                     <FormControlLabel
//                       value="2"
//                       control={<Radio />}
//                       label="Antenna-2"
//                     />
//                     <FormControlLabel
//                       value="3"
//                       control={<Radio />}
//                       label="Antenna-3"
//                     />
//                     <FormControlLabel
//                       value="4"
//                       control={<Radio />}
//                       label="Antenna-4"
//                     />
//                     <FormControlLabel
//                       value="8"
//                       control={<Radio />}
//                       label="Antenna-8"
//                     />
//                   </RadioGroup>
//                 </FormControl>
//               </Grid>

//               {/*Epc   */}

//               <Grid item lg={8} xs={12}>
//                 <TextField
//                   label={t("text.EpcNumber")}
//                   value={epcnumber}
//                   placeholder={t("text.EpcNumber")}
//                   size="small"
//                   fullWidth
//                 />
//               </Grid>

//               <Grid item lg={2} sm={2} xs={2}>
//                 <Grid>
//                   <Button
//                     fullWidth
//                     style={{
//                       backgroundColor: "#059669",
//                       color: "white",
//                       marginTop: "2px",
//                     }}
//                     onClick={() => getepc()}
//                   >
//                     {t("text.GetEpc")}
//                   </Button>
//                 </Grid>
//               </Grid>

//               {/*Accession-No  */}
//               <Grid xs={12} sm={8} item>
//                 <Autocomplete
//                   disablePortal
//                   id="combo-box-demo"
//                   options={option}
//                   fullWidth
//                   // value={
//                   //   option.find(
//                   //     (option) => option.value === formik.values.fileID
//                   //   ) || null
//                   // }
//                   size="small"
//                   onChange={(event, newValue) => {
//                     if (newValue == null) {
//                       formik.setFieldValue("fileID", "");
//                     } else {
//                       console.log(newValue?.value);
//                       formik.setFieldValue("fileID", newValue?.value);
//                       formik.setFieldValue("fileName", newValue?.label);
//                       formik.setFieldTouched("fileID", true);
//                       formik.setFieldTouched("fileID", false);
//                     }
//                   }}
//                   renderInput={(params) => (
//                     <TextField
//                       {...params}
//                       label={
//                         <span>
//                           {t("text.selectfiledetails")}{" "}
//                           {requiredFields.includes("dept_id") && (
//                             <span
//                               style={{
//                                 color: formik.values.fileID ? "green" : "red",
//                               }}
//                             >
//                               *
//                             </span>
//                           )}
//                         </span>
//                       }
//                     />
//                   )}
//                 />
//                 {formik.touched.fileID && formik.errors.fileID ? (
//                   <div style={{ color: "red", margin: "5px" }}>
//                     {formik.errors.fileID}
//                   </div>
//                 ) : null}
//               </Grid>

//               <Grid item lg={1.5} sm={1.5} xs={1.5}>
//                 <Grid>
//                   <Button
//                     fullWidth
//                     style={{
//                       backgroundColor: "#059669",
//                       color: "white",
//                       marginTop: "2px",
//                     }}
//                     disabled={assignbtn}
//                     onClick={() => assignbook()}
//                   >
//                     {t("text.AssignBook")}
//                   </Button>
//                 </Grid>
//               </Grid>

//               <Grid item lg={1.5} sm={1.5} xs={1.5}>
//                 <Grid>
//                   <Button
//                     fullWidth
//                     style={{
//                       backgroundColor: "#1E2952",
//                       color: "white",
//                       marginTop: "2px",
//                     }}
//                     onClick={handledeleteClick}
//                   >
//                    {t("text.EPCDelete")}
//                   </Button>
//                 </Grid>
//               </Grid>

//               <Grid xs={12} sm={8} item>
//                 <Autocomplete
//                   disablePortal
//                   id="combo-box-demo"
//                   options={LocationOption}
//                   fullWidth
//                   // value={
//                   //   LocationOption.find(
//                   //     (LocationOption) => LocationOption.value === formik.values.id
//                   //   ) || null
//                   // }
//                   size="small"
//                   onChange={(event, newValue) => {
//                     if (newValue == null) {
//                       formik.setFieldValue("currentLocation", "");
//                     } else {
//                       console.log(newValue?.value);
//                       formik.setFieldValue("currentLocation", newValue?.value);
//                       // formik.setFieldValue("fileName", newValue?.label);
//                       formik.setFieldTouched("currentLocation", true);
//                       formik.setFieldTouched("currentLocation", false);
//                     }
//                   }}
//                   renderInput={(params) => (
//                     <TextField
//                       {...params}
//                       label={
//                         <span>
//                           {t("text.selectMapLoc")}{" "}
//                           {requiredFields.includes("currentLocation") && (
//                             <span
//                               style={{
//                                 color: formik.values.id ? "green" : "red",
//                               }}
//                             >
//                               *
//                             </span>
//                           )}
//                         </span>
//                       }
//                     />
//                   )}
//                 />
//                 {formik.touched.id && formik.errors.id ? (
//                   <div style={{ color: "red", margin: "5px" }}>
//                     {formik.errors.id}
//                   </div>
//                 ) : null}
//               </Grid>

//               <Grid item lg={3} sm={3} xs={3}>
//                 <Grid>
//                   <Button
//                     fullWidth
//                     style={{
//                       backgroundColor: "#059669",
//                       color: "white",
//                       marginTop: "2px",
//                     }}
//                     onClick={() => assignLocation()}
//                   >
//                    {t("text.AssignLocation")}
//                   </Button>
//                 </Grid>
//               </Grid>
//               {/*button  */}
//               <Grid
//                 item
//                 xs={12}
//                 container
//                 spacing={2}
//                 alignItems="center"
//                 justifyContent="center"
//               >
//                 <Grid item lg={2} sm={2} xs={2}>
//                   <Button
//                     type="reset"
//                     fullWidth
//                     style={{
//                       backgroundColor: "#F43F5E",
//                       color: "white",
//                       marginTop: "10px",
//                       // marginLeft:"50px",
//                     }}
//                     //onClick={(e) => formik.resetForm()}
//                   >
//                     {t("text.reset")}
//                   </Button>
//                 </Grid>
//               </Grid>
//             </Grid>
//           </form>
//         </CardContent>
//       </div>
//     </div>
//   );
// };

// export default FileAssigning;
